const fields = [
  {
    key: 'id',
    field: 'id',
    title: 'Id',
    label: 'id',
    cell: 'navigation',
    sortable: true,
    hidden: false,
  },
  {
    field: 'key',
    title: 'Key',
    sortable: true,
    hidden: false,
  },
  {
    field: 'value',
    title: 'Value',
    sortable: true,
    hidden: false,
  },
  {
    field: 'description',
    title: 'Description',
    sortable: true,
    hidden: false,
  },
  {
    field: '',
    title: '',
    cell: '',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
];

export default fields;
